/* First-party campaign attribution.
 *
 * Put UTM params on the links you share so you can tell campaigns apart:
 *   Facebook:    https://www.danielrayrangel.com/?utm_source=facebook&utm_medium=social&utm_campaign=spring
 *   Coupon QR:   https://www.danielrayrangel.com/?utm_source=coupon&utm_medium=qr&utm_campaign=spring
 *
 * We store the FIRST touch (the campaign that first brought them) so it
 * survives navigation and sticks to the lead when they finally submit, plus
 * the LAST touch. No third-party tracker — this is your own data.
 */

const KEY = "exhale_attr";

function parseCurrent() {
  const p = new URLSearchParams(window.location.search);
  return {
    utm: {
      source: p.get("utm_source"),
      medium: p.get("utm_medium"),
      campaign: p.get("utm_campaign"),
      term: p.get("utm_term"),
      content: p.get("utm_content"),
    },
    fbclid: p.get("fbclid"),
    referrer: document.referrer || null,
    landing: window.location.pathname + window.location.search,
    at: new Date().toISOString(),
  };
}

function hasCampaign(touch) {
  return Boolean(
    touch.fbclid ||
      (touch.utm && Object.values(touch.utm).some(Boolean))
  );
}

export function captureAttribution() {
  try {
    const current = parseCurrent();
    const saved = JSON.parse(localStorage.getItem(KEY) || "null");

    if (!saved) {
      // First visit ever — this becomes first touch (and last touch).
      localStorage.setItem(
        KEY,
        JSON.stringify({ firstTouch: current, lastTouch: current })
      );
      return;
    }
    // Returning: only move "last touch" when a new campaign param shows up,
    // so plain repeat visits don't overwrite the real source.
    if (hasCampaign(current)) {
      saved.lastTouch = current;
      localStorage.setItem(KEY, JSON.stringify(saved));
    }
  } catch (e) {
    /* localStorage blocked (private mode, etc.) — fail quietly */
  }
}

export function getAttribution() {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || "null");
    return {
      first_touch: saved ? saved.firstTouch : parseCurrent(),
      last_touch: saved ? saved.lastTouch : null,
      referrer: document.referrer || null,
    };
  } catch (e) {
    return { first_touch: null, last_touch: null, referrer: document.referrer || null };
  }
}
